import { useEffect, useState } from "react";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { fmtDateTime, title } from "../lib/format";
import { PageHeader, Loading, Empty } from "../components/kit";
import { Input } from "../components/ui/input";

export default function AuditLogs() {
  const { stores } = useAuth();
  const [rows, setRows] = useState(null);
  const [q, setQ] = useState("");
  useEffect(() => { api.get("/audit-logs").then((r) => setRows(r.data)); }, []);
  const name = (id) => stores.find((s) => s.id === id)?.name || "—";
  const list = (rows || []).filter((r) => !q || `${r.action} ${r.detail} ${r.employee_id} ${r.user_name}`.toLowerCase().includes(q.toLowerCase()));

  return (
    <div className="space-y-8">
      <PageHeader eyebrow="Security & changes" title="Audit Logs" testid="audit-title"
        right={<Input placeholder="Search" value={q} onChange={(e) => setQ(e.target.value)} className="w-64 h-11" data-testid="audit-search-input" />} />
      {!rows ? <Loading /> : (
        <div className="bs-card overflow-x-auto">
          <table className="w-full text-left text-sm" data-testid="audit-table">
            <thead className="text-xs uppercase tracking-wider text-slate-500 border-b border-slate-100"><tr>{["When", "Who", "Action", "Detail", "Store"].map((h) => <th key={h} className="px-5 py-4">{h}</th>)}</tr></thead>
            <tbody>
              {list.map((r) => (
                <tr key={r.id} className="border-b border-slate-50">
                  <td className="px-5 py-3 whitespace-nowrap text-slate-500">{fmtDateTime(r.at)}</td>
                  <td className="px-5 font-medium text-[#011E38]">{r.user_name} <span className="text-xs text-slate-400">{r.employee_id}</span></td>
                  <td className="px-5"><span className="rounded-full bg-slate-100 px-2.5 py-0.5 text-xs font-semibold">{title(r.action)}</span></td>
                  <td className="px-5 text-slate-700">{r.detail}</td>
                  <td className="px-5 text-slate-500">{r.store_id ? name(r.store_id) : "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
          {!list.length && <Empty>No log entries.</Empty>}
        </div>
      )}
    </div>
  );
}
